import chalk from 'chalk';

/**
 * 显示CLI工具欢迎Banner
 */
export function showBanner(): void {
  const banner = `
  ┌───────────────────────────────────────────────┐
  │                                               │
  │   ${chalk.blue('Create MCP CLI')}                              │
  │                                               │
  │   ${chalk.green('快速创建基于MCP协议的项目')}                    │
  │                                               │
  └───────────────────────────────────────────────┘
  `;

  console.log(banner);
}
